import { render, staticRenderFns } from "./AnalystRating.vue?vue&type=template&id=3d06f42b&"
import script from "./AnalystRating.vue?vue&type=script&lang=js&"
export * from "./AnalystRating.vue?vue&type=script&lang=js&"
import style0 from "./AnalystRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-analyst-rating/src/components/analystRating/AnalystRating.vue"
export default component.exports